import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';

/**
 * InactivityWarningModal
 * Shows a warning when user has been inactive for 28 minutes.
 */
const InactivityWarningModal = ({ onStayLoggedIn, onLogoutNow }) => {
  const [secondsLeft, setSecondsLeft] = useState(120); // 2 minutes

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeStr = `${minutes}:${seconds?.toString()?.padStart(2, '0')}`;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className="w-full max-w-sm rounded-2xl p-6 shadow-2xl"
        style={{
          background: 'var(--color-card)',
          border: '1px solid rgba(245,158,11,0.4)',
          boxShadow: '0 0 40px rgba(245,158,11,0.15)',
        }}
      >
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center"
            style={{ background: 'rgba(245,158,11,0.15)', border: '2px solid rgba(245,158,11,0.4)' }}
          >
            <Icon name="Clock" size={28} color="#F59E0B" />
          </div>
        </div>

        {/* Title */}
        <h3 className="font-heading text-lg font-bold text-foreground text-center mb-2">
          Session Expiring Soon
        </h3>
        <p className="text-sm text-muted-foreground text-center mb-1">
          You've been inactive for 28 minutes. You'll be logged out in:
        </p>

        {/* Countdown */}
        <div className="flex justify-center my-4">
          <div
            className="px-6 py-3 rounded-xl font-heading text-3xl font-bold"
            style={{
              background: secondsLeft <= 30 ? 'rgba(239,68,68,0.15)' : 'rgba(245,158,11,0.1)',
              color: secondsLeft <= 30 ? 'var(--color-error, #EF4444)' : '#F59E0B',
              border: `1px solid ${secondsLeft <= 30 ? 'rgba(239,68,68,0.3)' : 'rgba(245,158,11,0.3)'}`,
            }}
          >
            {timeStr}
          </div>
        </div>

        <p className="text-xs text-muted-foreground text-center mb-5">
          2 minutes remaining before automatic logout
        </p>

        {/* Actions */}
        <div className="flex flex-col gap-2">
          <button
            onClick={onStayLoggedIn}
            className="w-full py-3 rounded-xl font-semibold text-sm transition-all"
            style={{
              background: 'var(--color-primary)',
              color: 'var(--color-primary-foreground, #0a0a0a)',
            }}
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogoutNow}
            className="w-full py-3 rounded-xl font-semibold text-sm border border-border text-muted-foreground hover:text-foreground hover:border-foreground/30 transition-all"
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactivityWarningModal;
